import { Component, ChangeDetectionStrategy, Output, EventEmitter, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { JobTitleUI } from 'src/models';
import { AlertService, JobTitleService } from 'src/core/services';
import { TranslateService } from '@ngx-translate/core';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'app-job-titles',
  templateUrl: './job-titles.component.html',
  styleUrls: ['./job-titles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobTitlesComponent extends BaseResizableComponent {
  private readonly jobTitleService = inject(JobTitleService);
  private readonly translateService = inject(TranslateService);
  private readonly alertService = inject(AlertService);

  @Output() save = new EventEmitter<JobTitleUI[]>();

  allJobTitles$ = this.jobTitleService.allJobTitles$;

  override ngOnInit(): void {
    super.ngOnInit();

    this.jobTitleService.getAllJobTitles();
  }

  onSave(visibleJobTitles: JobTitleUI[]) {
    this.jobTitleService
      .saveJobTitles(visibleJobTitles)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(() => {
        this.jobTitleService.getAllJobTitles();
        this.jobTitleService.getJobTitles();
        this.alertService.success(this.translateService.instant('components.jobTitles.alerts.successes.saveJobTitles'));

        this.save.emit(visibleJobTitles);
      });
  }
}
